import React from 'react'
import { ReactTypeformEmbed } from 'react-typeform-embed'
import { Container, Row } from 'reactstrap'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import uuid from 'uuid'
import { signout } from '../../redux/actions/userActions'
import '../../scss/component/assessments/assessment.scss';
class AssessmentForms extends React.Component {
  render () {
    return (
      <Container
        className={`typeform-container ${this.props.i === this.props.categoryIndex ? 'display' : 'invisible'}`}
        key={uuid()}>
        <Row>
          <ReactTypeformEmbed url={this.props.url} />
        </Row>
      </Container>
    )
  }
}
export default connect(null, { signout })(withRouter(AssessmentForms))



// WEBPACK FOOTER //
// ./src/components/training/TypeformView.js